import React from "react";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Layout";
import { mainItemsHref } from "../../store/localItems";
import { useSelector } from "react-redux";
import { formatNotificationCount, getNotificationCountForPath } from "../../utils/adminNotificationUtils";

const Home = () => {
  const counts = useSelector((state) => state.notification.unreadByType);
  return (
    <Layout sidebar>
      <div className="home">
        <h1 className="home__title">Главная страница</h1>
        <div className="home__grid">
          {mainItemsHref.map((item, index) => (
            <NavLink key={index} to={item.href} className="home__card">
              {getNotificationCountForPath(item.href, counts) > 0 && (
                <b className="admin-notification-badge home__notification-badge" title={"Непрочитанных уведомлений: " + getNotificationCountForPath(item.href, counts)}>
                  {formatNotificationCount(getNotificationCountForPath(item.href, counts))}
                </b>
              )}
              <div className="home__icon">{item.icon}</div>
              <div className="home__label">{item.text}</div>
            </NavLink>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Home;
